import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { GraphContext } from "../context";

const ResultComponent = ({ content, typingSpeed }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayedContent, setDisplayedContent] = useState([]);

  useEffect(() => {
    if (content.length === 0 && displayedContent.length > 0) {
      setDisplayedContent([]);
      setCurrentIndex(0);
      return;
    }
    const startTyping = () => {
      if (currentIndex < content.length) {
        const currentContent = content[currentIndex];
        const nextContent = displayedContent.concat([currentContent]);
        setDisplayedContent(nextContent);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }
    };

    const typingInterval = setInterval(startTyping, typingSpeed);

    return () => {
      clearInterval(typingInterval);
    };
  }, [content, currentIndex, displayedContent, typingSpeed]);

  const finalPathisThere =
    content.length > 0 &&
    content[content.length - 1].props.children.includes("Final Path is:");
  return (
    <Grid
      flex={0.2}
      padding={2}
      style={{ overflowY: "scroll" }}
      backgroundColor="#0f1629"
    >
      <Typography
        textAlign={"center"}
        color={"red"}
        fontWeight={"bold"}
        textTransform={"uppercase"}
        paddingY={2}
      >
        Operations
      </Typography>
      {content.length > 0 ? (
        <>
          {displayedContent.map((content, index) => (
            <Grid
              style={{
                padding: 6,
                backgroundColor: "grey",
                marginBottom: 5,
                borderRadius: 10,
                boxshadow: "rgba(0, 0, 0, 0.2) 0px 7px 29px 0px",
              }}
              key={index}
              className="typewriter-line"
            >
              {content}
            </Grid>
          ))}
          {currentIndex === content.length && !finalPathisThere && (
            <Grid
              style={{
                padding: 6,
                backgroundColor: "white",
                marginBottom: 5,
                borderRadius: 10,
                boxshadow: "rgba(255 255 255, 0.9) 0px 7px 29px 0px",
              }}
            >
              <p style={{ color: "black", fontWeight: "600" }}>
                No Such Path{"   "}
              </p>
            </Grid>
          )}
        </>
      ) : null}
    </Grid>
  );
};

export default ResultComponent;
